import styles from './ContactHost.module.scss';
import formStyles from 'legacy/common/components/form/Form.module.scss';

import classnames from 'classnames';
import * as Yup from 'yup';
import { Field, Form, Formik } from 'formik';

import { useContactHostMutation } from 'legacy/events/hooks';

import * as toast from 'legacy/common/utils/toast';
import Modal, { ModalType } from 'legacy/common/components/modal/Modal';
import Button, { ButtonType } from 'legacy/common/components/button/Button';

const ContactHostSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  email: Yup.string().email('Invalid Email').required('Email is required'),
  message: Yup.string().required('Message is required')
});

type ContactHostModalProps = {
  eventId: string;
  onClose: () => void;
};

const ContactHostModal: React.FC<ContactHostModalProps> = ({
  eventId,
  onClose
}) => {
  const {
    mutate: contactHostMutate,
    isLoading,
    error,
    reset
  } = useContactHostMutation();

  return (
    <Modal
      type={ModalType.SMALL}
      visible
      onClose={() => {
        onClose();
        reset();
      }}
    >
      <div className={styles.container}>
        <Formik
          validationSchema={ContactHostSchema}
          initialValues={{
            name: '',
            email: '',
            message: ''
          }}
          onSubmit={(values) => {
            contactHostMutate(
              { eventId, details: values },
              {
                onSuccess: () => {
                  onClose();
                  toast.success('Your message has been sent to the event host');
                }
              }
            );
          }}
        >
          {({ errors, touched }) => (
            <Form className={formStyles.container}>
              <h1 className={styles.title}>Contact Host</h1>
              <div className={formStyles.formError}>{error?.message}</div>
              <div className={formStyles.group}>
                <div className={formStyles.label}>Name</div>
                <Field
                  id="name"
                  name="name"
                  type="text"
                  placeholder="Enter your name"
                  className={classnames(formStyles.input, {
                    [formStyles.errorField]: errors.name && touched.name
                  })}
                />
                {errors.name && touched.name && (
                  <div className={formStyles.error}>{errors.name}</div>
                )}
              </div>

              <div className={formStyles.group}>
                <div className={formStyles.label}>Email</div>
                <Field
                  id="email"
                  name="email"
                  type="text"
                  placeholder="Enter your email"
                  className={classnames(formStyles.input, {
                    [formStyles.errorField]: errors.email && touched.email
                  })}
                />
                {errors.email && touched.email && (
                  <div className={formStyles.error}>{errors.email}</div>
                )}
              </div>

              <div className={formStyles.group}>
                <div className={formStyles.label}>Message</div>
                <Field
                  rows={9}
                  id="message"
                  name="message"
                  as="textarea"
                  placeholder="Enter your message"
                  className={classnames(formStyles.textarea, {
                    [formStyles.errorField]: errors.message && touched.message
                  })}
                />
                {errors.message && touched.message && (
                  <div className={formStyles.error}>{errors.message}</div>
                )}
              </div>

              <div className={formStyles.group}>
                <Button isSubmit loading={isLoading} type={ButtonType.Primary}>
                  Send Message
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Modal>
  );
};

export default ContactHostModal;
